import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./OurValues.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import OurValuesBox from "../../../Component/ReuseComponent/OurValuesBox/OurValuesBox";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";

export default function OurValuesArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    dispatch(fetchPageData({ page_id: 3, lang: "ar" }));
  }, [dispatch]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");
  const section4 = data.find((s) => s.section_id === "4");
  const section5 = data.find((s) => s.section_id === "5");
  const section6 = data.find((s) => s.section_id === "6");

  return (
    <>
      <LoaderWrap>
        <div className="OurValuesContainer">
          <section>
            <OurValuesS1 section1={section1} section2={section2} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurValuesS2">
            <OurValuesS2 section3={section3} section4={section4} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurValuesS3">
            <OurValuesS3 section5={section5} section6={section6} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function OurValuesS1({ section1, section2 }) {
  return (
    <>
      <div className="OurValuesS1">
        <TC3L Head="القيم الخاصة بنا" />
        <div className="OurValuesBoxContAr">
          <OurValuesBox Image={section1?.image} ImageAlt="" Head={section1?.title} Title={section1?.description} Height="31vw" />
          <OurValuesBox Image={section2?.image} ImageAlt="" Head={section2?.title} Title={section2?.description} Height="31vw" />
        </div>
      </div>
    </>
  );
}
function OurValuesS2({ section3, section4 }) {
  return (
    <>
      <div className="OurValuesS2">
        <div className="OurValuesBoxContAr">
          <OurValuesBox Image={section3?.image} ImageAlt="" Head={section3?.title} Title={section3?.description} Height="31vw" />
          <OurValuesBox Image={section4?.image} ImageAlt="" Head={section4?.title} Title={section4?.description} Height="31vw" />
        </div>
      </div>
    </>
  );
}
function OurValuesS3({ section5, section6 }) {
  return (
    <>
      <div className="OurValuesS3">
        <div className="OurValuesBoxContAr">
          <OurValuesBox Image={section5?.image} ImageAlt="" Head={section5?.title} Title={section5?.description} Height="31vw" />
          <OurValuesBox Image={section6?.image} ImageAlt="" Head={section6?.title} Title={section6?.description} Height="31vw" />
        </div>
      </div>
    </>
  );
}
